import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MaterialModule } from 'src/app/material/material.module';
import { HeaderComponent } from '../header/header.component';
import { NavComponent } from './nav.component';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../../../../../../../environments/environment';
import { FocusWithinDirective } from './directives/focus-within.directive';

const config = {
  issuer: environment.okta.clientConfig.issuer,
  clientId: environment.okta.clientConfig.clientId,
  redirectUri: environment.okta.clientConfig.redirectUri,
  pkce: environment.okta.clientConfig.pkce,
  postLogoutRedirectUri: environment.okta.clientConfig.postLogoutRedirectUri,
};

const oktaAuth = new OktaAuth(config);

@NgModule({
  declarations: [NavComponent, HeaderComponent, FocusWithinDirective],
  imports: [RouterModule, MaterialModule, CommonModule, OktaAuthModule, FontAwesomeModule],
  exports: [NavComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: OKTA_CONFIG,
      useValue: { oktaAuth },
    },
  ],
})
export class NavComponentModule {}
